export const saveIsPermanentChange = (status) => {
  return localStorage.setItem("SaveInLocalIsPermanentChange", status);
};

export const getIsPermanentChange = () => {
  return localStorage.getItem("SaveInLocalIsPermanentChange");
};

export const removeIsPermanentChange = () => {
  return localStorage.removeItem("SaveInLocalIsPermanentChange");
};
